module.exports = {"321203001":"口岸街道","321203002":"刁铺街道","321203003":"许庄街道","321203100":"永安洲镇","321203101":"白马镇","321203103":"胡庄镇","321203104":"大泗镇","321203400":"泰州市高港区科技创业园管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321203.json
// module id = 855
// module chunks = 0